// Declarative audit contract for standard CV content, separate from provenance,
// source IDs, internal validation metadata and duplicated compatibility aliases.
export function listPopulatedCvFields(draft) {
    const fields = [];
    const hasValue = value => Array.isArray(value) ? value.some(item => String(item ?? '').trim())
        : value === true || (value != null && value !== false && String(value).trim() !== '');
    const add = (object, path, names) => names.forEach(name => {
        if (hasValue(object?.[name])) fields.push({ path: `${path}.${name}`, value: object[name] });
    });
    const sections = (rows, path) => (rows || []).forEach((section, index) => add(section, `${path}.${index}`, ['title','content','items']));
    add(draft.candidate, 'candidate', ['full_name','title','subtitle','years_of_experience','computed_years_of_experience','location','summary','email','phone','links']);
    (draft.skills?.highlighted || []).forEach((value, index) => fields.push({path:`skills.highlighted.${index}`,value}));
    (draft.skills?.categories || []).forEach((category, index) => {
        add(category, `skills.categories.${index}`, ['name']);
        (category.items || []).forEach((value, itemIndex) => fields.push({path:`skills.categories.${index}.items.${itemIndex}`,value}));
    });
    const scope = (object, path, project) => {
        add(object, path, project
            ? ['name','client','role','context','start_date','end_date','is_current','group_id','responsibilities','achievements','environment','technical_environment','functional_environment','urls']
            : ['company','client','role','location','summary','start_date','end_date','is_current','responsibilities','achievements','technical_environment','functional_environment']);
        sections(object.sections, `${path}.sections`);
    };
    (draft.experiences || []).forEach((experience, index) => {
        scope(experience, `experiences.${index}`, false);
        (experience.missions || []).forEach((mission, i) => scope(mission, `experiences.${index}.missions.${i}`, true));
        (experience.project_groups || []).forEach((group, i) => scope(group, `experiences.${index}.project_groups.${i}`, true));
    });
    (draft.education || []).forEach((value,index) => add(value, `education.${index}`, ['title','institution','year','details']));
    (draft.certifications || []).forEach((value,index) => add(value, `certifications.${index}`, ['name','issuer','year']));
    (draft.languages || []).forEach((value,index) => add(value, `languages.${index}`, ['name','level']));
    (draft.projects || []).forEach((value,index) => add(value, `projects.${index}`, ['name','role','description','technologies','start_date','end_date','url']));
    sections(draft.additional_sections, 'additional_sections');
    return fields;
}

export function auditCvFormCoverage(container, draft) {
    const controls = new Map();
    container.querySelectorAll('[data-cv-path]').forEach(element => {
        [element.dataset.cvPath, ...(element.dataset.cvIncludes || '').split(',')].filter(Boolean).forEach(path => {
            if (!controls.has(path)) controls.set(path, []);
            controls.get(path).push(element);
        });
    });
    const normalize = value => String(value ?? '').replace(/\s+/g, ' ').trim();
    return listPopulatedCvFields(draft).flatMap(({path,value}) => {
        const elements = controls.get(path) || [];
        if (!elements.length) return [{path,reason:'field_not_present_in_editor'}];
        const values = Array.isArray(value) ? value : [value];
        const present = values.every(item => elements.some(element => {
            if (typeof item === 'boolean') return element.checked === item || element.getAttribute('aria-checked') === String(item);
            const shown = ['INPUT','TEXTAREA','SELECT'].includes(element.tagName) ? element.value : element.textContent;
            return normalize(shown).includes(normalize(item));
        }));
        return present ? [] : [{path,reason:'stored_value_not_displayed'}];
    });
}
